<template>
  <div>
    <div
    v-if="
      $route.path.indexOf('_detail') === -1 &&$route.path.indexOf('_edit') === -1
    "
  >
    <el-row :gutter="24">
      <el-col :span="3">
        <el-input
          placeholder="充值卡号"
          v-model="params.card_num"
          style="width: 100%"
          size="mini"
          clearable
        ></el-input>
      </el-col>
      <el-col :span="3">
        <el-select v-model="params.card_last_num" filterable clearable size="mini" @clear="clear('card_last_num')"  placeholder="请选择e卡通种类">
          <el-option
           :label="item.card_type_text+':'+item.frist_num"
           :value="item.frist_num" v-for="(item,index) in datatypeList"
           :key="index"
           ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="params.card_status" clearable size="mini" @clear="clear('card_status')"  placeholder="使用状态">
          <el-option label="未使用"value="0"></el-option>
          <el-option label="已使用"value="1"></el-option>
          <el-option label="已作废"value="2"></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="params.card_play_status" clearable size="mini" @clear="clear('card_play_status')"  placeholder="卡状态">
          <el-option label="正常"value="0"></el-option>
          <el-option label="作废"value="1"></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="searchData" size="mini"
          >搜索</el-button
        >
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button type="primary" @click="refresh()" size="mini">刷新数据</el-button>
        <el-button type="primary" @click="toAdd()" size="mini">新增+</el-button>
        <el-button type="primary" @click="exportData()" size="mini">导出</el-button>
        <el-button type="primary" @click="exportLogData()" size="mini">日志导出</el-button>
      </el-col>
    </el-row>
    <el-table :data="dataList" :height="wheight - 130" v-loading="loading">

      <el-table-column
        prop="card_num"
        label="充值卡号"
      ></el-table-column>
        <el-table-column
          label="使用状态"
        >

        <template slot-scope="scope">
          <el-tag
           v-if="scope.row.card_status == '0'"
            size="mini"
            type="success"
            >{{scope.row.card_status_text}}</el-tag
          >
          <el-tag
            v-else-if="scope.row.card_status == '1'"
            size="mini"
             type="primary"
            >{{scope.row.card_status_text}}</el-tag
          >
          <el-tag
           type="info"
           v-else
            size="mini"
            >{{scope.row.card_status_text}}</el-tag
          >
        </template>
        </el-table-column>
        <el-table-column
          label="卡状态"
        >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.card_play_status == '0'"
                size="mini"
                type="success"
                >{{scope.row.card_play_status_text}}</el-tag
              >
              <el-tag
                v-else
                size="mini"
                 type="info"
                >{{scope.row.card_play_status_text}}</el-tag
              >
            </template>
        </el-table-column>
        <el-table-column
          prop="card_type_text"
          label="充值卡类型"
        >
        </el-table-column>
        <el-table-column
          prop="card_size_text"
          label="怡康币数量"
        ></el-table-column>
        <el-table-column
          prop="card_addvance_text"
          label="预存款金额"
        ></el-table-column>
        <el-table-column
          prop="card_last_num"
          label="流水号"
        ></el-table-column>
        <el-table-column
          prop="card_frist_num"
          label="前段码"
        ></el-table-column>
        <el-table-column
          prop="card_city"
          label="发卡城市"
        ></el-table-column>
        <el-table-column
          prop="card_time"
          label="发卡时间"
        ></el-table-column>
        <el-table-column
          prop="card_people"
          label="发卡人"
        ></el-table-column>
        <el-table-column
          prop="mobile"
          label="使用人手机号"
        ></el-table-column>
    </el-table>
    <div class="content-center content-top-padded">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50]"
        :total="total_count"
        :page-size="params.pagesize"
      >
      </el-pagination>
    </div>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form  :model="form" class="demo-form-inline">
        <el-form-item label="请选择e卡通种类">
          <el-select v-model="form.card_frist_num" filterable value-key="card_id" @change="changeCardType"  placeholder="请选择e卡通种类">
            <el-option
             :label="item.card_type_text+':'+item.frist_num"
             :value="item.frist_num" v-for="(item,index) in datatypeList"
             :key="index"
             ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="现金面额">
           <div style="color: red;">{{form.card_rmb}}(元)</div>
        </el-form-item>
        <el-form-item label="康币面额">
          <div style="color: red;">{{form.card_currency_num}}(元)</div>
        </el-form-item>

         <el-form-item label="发卡城市">
           <el-select v-model="form.card_city" placeholder="e发卡城市">
             <el-option label="西安" value="01"></el-option>
             <el-option label="咸阳" value="02"></el-option>
           </el-select>
         </el-form-item>
         <el-form-item label="发卡数量">
           <el-input v-model.number="form.card_count" style="width:200px;"  placeholder="发卡数量"></el-input>
         </el-form-item>
          <el-form-item>
             <div style="text-align: center;" >
                 <el-button type="primary" @click="onSubmit" :disabled="disabled">确认保存</el-button>
             </div>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="日志导出" :visible.sync="exportdialogFormVisible">
      <el-form :model="logform">
        <el-date-picker
          v-model="logform.times"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-button @click="exportLog()">确认导出</el-button>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportdialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="exportdialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
   <router-view></router-view>
  </div>
</template><script>
import { mapGetters } from "vuex";
import {
  getEcardList,
  ecardExport,
  createEcard,
  changeCardPlayStatus,
  getEcardTypeList,
  ecardlogExport
} from "../../../api/member";

export default {
  components: {},
  data() {
    return {
      total_count: 0,
      params: {
        page: 1,
        pagesize: 20,
      },
      exportdialogFormVisible:false,
      datatypeList:[],
      dataList: [],
      logform:{
        times:''
      },
      loading: false,
      dialogVisible:false,
      title:'生成卡号',
      form:{
        card_city:"01",
        card_frist_num:'',
        card_rmb:'0.00',
        card_currency_num:'0.00',
        card_count:100
      },
      disabled:false,
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  methods: {
    clear(name){
      this.params[name]='';
    },
    refresh(){
        this.params={};
        this.params.page = 1;
        this.getDataList();
    },
    handleClose(){
       this.dialogVisible=false;
       that.disabled = false;
    },
    onSubmit(){
       var that = this;
       this.$confirm("确定要生成？", "提示", {
         cancelButtonText: "取消",
         confirmButtonText: "确定",
         type: "warning",
         beforeClose: (action, instance, done) => {

           if (action === "confirm") {
             createEcard(that.form).then((res) => {
               if (res.status) {
                   that.$message({
                     message: "生成成功!",
                     type: "success",
                     duration: 2000,
                   });
                   that.disabled = true;
               }
             });
           }
           done();
         },
       });
    },
    toAdd() {
       this.dialogVisible=true;
    },
    changeCardType(event){
      var data =this.datatypeList;
       for(let i=0;i<data.length;i++){
         if(data[i].frist_num == event){
            this.form.card_type =data[i].card_type;
            this.form.card_type_id =data[i].card_type_id;
            this.form.card_rmb =data[i].card_rmb  >0 ? data[i].card_rmb:"0.00";
            this.form.card_currency_num =data[i].card_currency_num >0 ? data[i].card_currency_num:"0.00";
            break;
         }
       }
    },
     getDataTypeList() {
       this.loading = true;
       getEcardTypeList({page:1,pagesize:1000})
         .then((response) => {
           this.datatypeList = response.data.data.list;
           this.total_count = response.data.data.total_count;
           this.loading = false;
           this.getDataList();
         })
         .catch((error) => {
           this.loading = false;
           this.$message({
             type: "error",
             message: "获取列表信息出错",
           });
         });
     },
    getDataList() {
      this.loading = true;
      getEcardList(this.params)
        .then((response) => {
          this.dataList = response.data.data.list;
          this.total_count = response.data.data.total_count;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "获取列表信息出错",
          });
        });
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      this.getDataList();
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pagesize = pageSize;
      this.getDataList();
    },
    //导出预留
    exportData() {
      this.$message({
        type: "success",
        message: "请稍后正在导出~",
      });
      ecardExport(this.params).then(res => {
          if (res.data.data.status) {
              var url = res.data.data.url
              window.open(url)
          } else {
              this.$notify({
                  title: '失败',
                  message: '出错了!',
                  type: 'error'
              })
          }
      })
    },
    exportLogData(){
      this.exportdialogFormVisible=true;
  },
  exportLog(){
    this.$message({
        type: "success",
        message: "请稍后正在导出~",
      });
      ecardlogExport(this.logform).then(res => {
          if (res.data.data.status) {
              var url = res.data.data.url
              window.open(url)
          } else {
              this.$notify({
                  title: '失败',
                  message: '出错了!',
                  type: 'error'
              })
          }
      })
  },
  },

  mounted() {
    this.getDataTypeList();
   

  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 90%;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
  img {
    width: 90%;
  }
}
.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// ecard.vue?1d2bf5e2